import { $RTKGlobalAPI } from 'shared/store'
import { RequestMethod } from 'shared/types/Api'

import { apiRoutes } from 'shared/config/apiPath/apiPath'

import {
  GetMeResponse,
  LoginArgs,
  LoginResponse,
  UserUpdateArgs,
  UserUpdateResponse,
  VerifyArgs,
  VerifyResponse,
} from './types'

const query = $RTKGlobalAPI.injectEndpoints({
  endpoints: builder => ({
    login: builder.mutation<LoginResponse, LoginArgs>({
      query: body => ({
        url: apiRoutes.auth.login,
        method: RequestMethod.POST,
        body,
      }),
    }),
    verify: builder.mutation<VerifyResponse, VerifyArgs>({
      query: body => ({
        url: apiRoutes.auth.verify,
        method: RequestMethod.POST,
        body,
      }),
    }),
    refreshToken: builder.mutation<VerifyResponse, string>({
      query: access => ({
        url: apiRoutes.auth.refresh,
        method: RequestMethod.POST,
        body: { access_token: access },
      }),
    }),
    updateUser: builder.mutation<UserUpdateResponse, Partial<UserUpdateArgs>>({
      query: ({ access, ...body }) => ({
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          Authorization: `Bearer ${access}`,
        },
        url: apiRoutes.user.update,
        method: RequestMethod.PUT,
        body,
      }),
    }),
    getMe: builder.query<GetMeResponse, void>({
      query: () => ({
        url: apiRoutes.user.me,
      }),
    }),
  }),
})

export const {
  useLoginMutation,
  useVerifyMutation,
  useUpdateUserMutation,
  useGetMeQuery,
  useLazyGetMeQuery,
  useRefreshTokenMutation,
  endpoints: authEndpoints,
} = query
